import { Tooltip, Typography } from 'antd';
import { useSelector } from 'react-redux';

import { selectDarkMode } from '../../../../userBrowserSettings/store/browserSettings.selectors';

import { getThemeColorClass, getTooltipOverlayClass } from '../../../../utils/helpers/themeHelpers';

import { getButtonHotkeyLabel } from './constants';

const classes = {
    customButtonsTooltip: 'custom-buttons-tooltip',
    tooltipOverlay: 'toolbar-tooltip-overlay',
};

const ToolbarTooltip = ({ disabled = false, title = '', placement = 'top', children }) => {
    const darkMode = useSelector(selectDarkMode);

    const tooltipOverlayClass = `${classes.tooltipOverlay} ${getTooltipOverlayClass(darkMode)}`;

    const toolbarTooltipTitle = (
        <div className={`${classes.customButtonsTooltip}`}>
            <Typography className={getThemeColorClass(darkMode)}>{title}</Typography>
            {getButtonHotkeyLabel(title)}
        </div>
    );

    return (
        <Tooltip
            placement={placement}
            overlayClassName={tooltipOverlayClass}
            title={disabled ? '' : toolbarTooltipTitle}
        >
            {children}
        </Tooltip>
    );
};

export default ToolbarTooltip;
